import React from 'react';
import { useDispatch, useSelector } from 'react-redux'
import { setLivefeedName } from 'actions/livefeed'
import EditorToggleButton from './ToolbarOptions/EditorToggleButton'
import AlignButton from './ToolbarOptions/AlignButton'
import ReUnDoButton from './ToolbarOptions//ReUnDoButton'
import DeleteOptionButton from './ToolbarOptions/DeleteOptionButton'
import AddEntityButton from './ToolbarOptions/AddEntityButton'
import FontSizeDropdown from './ToolbarOptions/FontSizeDropdown'
import FontFamilyDropdown from './ToolbarOptions//FontFamilyDropdown'
import FormatColor from './ToolbarOptions/FormatColor'
import TextOption from './ToolbarOptions/TextOption'
import BgColorOption from './ToolbarOptions/BgColorOption'
import './index.less'

const ToolbarContainer = () => {
    const dispatch = useDispatch();
    const { livefeedName, slideCurrentIndex, livefeedSlides, editorView, stepNumberState } = useSelector(state => state.livefeededitor)
    const { slideType, historyEntities, fontFamily, leftPanelBg, rightPanelBg, slideBg } = livefeedSlides.slice()[slideCurrentIndex]
    const history = historyEntities.slice(0);
    let currentEntity = history[stepNumberState];
    function liveFeedNameChangeHandler(e) {
        var name = e.target.value;
        dispatch(setLivefeedName(name));
    }

    return (
        <div className="tool-bar-row">
            <div className="flex--center">
                <div className="livefeed-name-col ">
                    <label> <b>Name:</b></label>
                    <input id="livefeed-editor-input-name" value={livefeedName} type="text" onChange={(e) => liveFeedNameChangeHandler(e)} required />
                </div>

                <div className="editor-toolbar flex--center">
                    {/* ------------------------ Align Toolbar options -------------------- */}
                    <AlignButton
                        currentEntity={currentEntity}
                        dispatch={dispatch}
                    />
                    {/* ------------------------ Delete,Add Toolbar options -------------------- */}
                    <DeleteOptionButton
                        currentEntity={currentEntity}
                        dispatch={dispatch}
                    />
                    <AddEntityButton
                        editorView={editorView}
                        livefeedSlides={livefeedSlides}
                        slideCurrentIndex={slideCurrentIndex}
                        dispatch={dispatch}
                    />
                    {/* ------------------------ Redo Undo Toolbar options -------------------- */}
                    <ReUnDoButton
                        stepNumberState={stepNumberState}
                        historyLength={history.length}
                        dispatch={dispatch}
                        editorView={editorView}
                    />
                    <div className="editor-toolbar__divider"></div>
                    {/* ------------------------ Text related Toolbar options -------------------- */}
                    <FontFamilyDropdown
                        editorView={editorView}
                        livefeedSlides={livefeedSlides}
                        slideCurrentIndex={slideCurrentIndex}
                        dispatch={dispatch}
                    />
                    <FontSizeDropdown
                        currentEntity={currentEntity}
                        dispatch={dispatch}
                    />
                    <BgColorOption
                        editorView={editorView}
                        currentEntity={currentEntity}
                        dispatch={dispatch}
                        leftPanelBg={leftPanelBg}
                        rightPanelBg={rightPanelBg}
                        slideType={slideType}
                        slideBg={slideBg}
                    />
                    <TextOption
                        dispatch={dispatch}
                        currentEntity={currentEntity}
                    />
                    <FormatColor
                        currentEntity={currentEntity}
                    />
                    {/* ------------------------ Toggle Editor view -------------------- */}
                    <EditorToggleButton
                        currentEntity={currentEntity}
                        editorView={editorView}
                        slideCurrentIndex={slideCurrentIndex}
                        dispatch={dispatch}
                        fontFamily={fontFamily}
                    />
                </div >
            </div >
        </div >
    );
}

export default ToolbarContainer;



// WEBPACK FOOTER //
// ./src/components/pages/livefeed/Editor/EditorContainer/ToolbarContainer/index.jsx